
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30720',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30720",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55233",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8280",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11737",
  "I18n": "static-7.1664",
  "quartz": "static-1.7384",
  "quartz-config": "static-1.1162",
  "quartz-core": "static-1.6603",
  "react-dlb": "static-1.85",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.77",
  "reselect": "static-3.9",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.873",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55220",
  "feedback-utils": "static-1.55224",
  "forms-embed-utils-lib": "static-1.4719",
  "forms-utils-lib": "static-1.13029",
  "foundations-assets": "static-1.5133",
  "foundations-components": "static-1.8400",
  "foundations-theming": "static-1.4717",
  "hub-http": "static-1.6467",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12044",
  "icons": "static-2.675",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4100",
  "raven": "static-3.5925",
  "react": "static-7.191",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-unify-reporter-duration-calculations.9",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5522",
  "react-virtualized": "static-2.104",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.496",
  "tinymce-plugins": "static-1.58130",
  "transmute": "static-2.85",
  "ui-images": "static-2.1231",
  "UIComponents": "static-3.8683",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3585",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3661",
  "quartz-webpack": "static-1.3608",
  "foundations-theming-specialty": "static-1.2433",
  "property-description-translator": "static-1.4094",
  "HeadJS": "static-2.790",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3391",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4571",
  "jasmine-runner": "static-1.6702",
  "opentelemetry-fe-types": "static-1.20",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4830",
  "mobile-manifest-mixins": "static-1.568",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.395",
  "quartz-auth": "static-1.1059",
  "quartz-head": "static-1.1049",
  "quartz-i18n": "static-1.1059",
  "quartz-routing": "static-1.814",
  "quartz-test": "static-1.1059",
  "quartz-tracking": "static-1.763",
  "trellis-components": "static-1.2513",
  "ui-fonts": "static-1.999",
  "usage-tracker-container": "static-1.7600",
  "usage-tracker-core": "static-1.7460",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7502",
  "reference-resolvers": "static-1.8433",
  "sanitize-text": "static-1.8404",
  "PatternValidationJS": "static-1.3151",
  "ReduxMessenger": "static-2.10619",
  "sanitize": "static-1.4728",
  "outpost": "static-1.4414",
  "rpc-client-utils": "static-1.4917",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4669",
  "floating-ui": "static-1.62",
  "hs-story-utils": "static-1.9680",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.63",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2494",
  "bend-plugin-foundations-theming": "static-1.3200",
  "foundations-theming-base": "static-1.3702",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.261",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "ai-components-ui-library": "static-1.9607",
  "atom": "static-1.5340",
  "codemirror": "static-5.99",
  "content-assistance-lib": "static-1.8141",
  "ContentUtils": "static-1.69063",
  "data-token-picker": "static-1.16822",
  "file-manager-components": "static-1.24374",
  "FileManagerCore": "static-1.39873",
  "FileManagerLib": "static-1.40014",
  "frontend-preferences-client": "static-1.8181",
  "hub-http-contrib": "static-1.3292",
  "interframe": "static-3.5008",
  "layout-dnd-components": "static-1.12900",
  "layout-dnd-utils": "static-1.11875",
  "property-translator": "static-1.5650",
  "react-codemirror": "static-1.10893",
  "react-colorpicker": "static-2.10462",
  "reference-resolvers-lite": "static-1.8354",
  "rich-text-lib": "static-1.20243",
  "tinymce-data": "static-1.41101",
  "tinymce-themes": "static-1.56986",
  "ui-addon-emoji-picker": "static-1.10138",
  "ui-addon-sales-email": "static-1.5468",
  "ui-brand-identity-lib": "static-1.16243",
  "bender-build-tools": "static-1.3382",
  "opentelemetry-web": "static-1.11",
  "hub-http-shared-msw-handlers": "static-1.10538",
  "hubspotter-http-shared-msw-handlers": "static-1.10536",
  "usage-tracker-session-replay": "static-1.5296",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1219",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.327",
  "chirp-fetch": "static-1.2146",
  "chatspot-core": "static-1.22675",
  "copilot-toolkit": "static-1.11758",
  "customer-data-objects-ui-components": "static-1.13283",
  "data-fetching-client": "static-1.9910",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5009",
  "ui-addon-video-player": "static-1.8956",
  "ui-coaching-tips": "static-1.29227",
  "usage-tracker": "static-1.7610",
  "cms-field-types": "static-1.5069",
  "content-icons-ui": "static-1.2318",
  "integrations-lib": "static-1.16939",
  "customer-data-objects": "static-1.7939",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1587",
  "apollo-link-hub-http": "static-2.4911",
  "apollo-stack-hubspot": "static-3.90",
  "graphql": "static-1.86",
  "immer": "static-1.94",
  "immerable": "static-1.4405",
  "ui-addon-iframeable": "static-1.9329",
  "video-components-external": "static-1.12075",
  "video-data-lib": "static-1.35733",
  "breeze-artifacts-sdk": "static-1.205",
  "audio-components": "static-1.6280",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29743",
  "FileManagerImages": "static-1.37525",
  "foundations-components-legacy": "static-1.1425",
  "html-to-image": "static-1.58",
  "redux-toolkit": "static-1.75",
  "salesImages": "static-1.530",
  "ui-universal-auth": "static-1.9304",
  "urlinator": "static-1.4785",
  "video-components": "static-1.14077",
  "video-embed": "static-1.36567",
  "ts-schema": "static-1.4261",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10200",
  "react-dnd-compat": "static-1.4869",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1795",
  "external-options-client-types": "static-1.4307",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7145",
  "hs-promise-utils": "static-1.5849",
  "inbound-db-properties-service-client": "static-1.4025",
  "NamespacedHubStyle": "static-2.9229",
  "growth-onboarding-confetti": "static-1.3315",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11396",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5723",
  "magpie-types": "static-1.5183",
  "simple-logging-lib": "static-1.3305",
  "avatar-components": "static-1.2750",
  "customer-data-ui-utilities": "static-1.10080",
  "growth-onboarding-feedback-components": "static-1.6837",
  "flux-actions": "static-1.361",
  "hubspot-apollo-client": "static-1.5133",
  "integrations-error-boundary-lib": "static-1.14354",
  "integrations-tracking-lib": "static-1.5862",
  "laboratory-lib": "static-3.7406",
  "native-integrations-shared-strings": "static-1.8031",
  "redux-observable": "static-1.72",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10518",
  "unified-auth": "static-1.818",
  "breeze-engine-chat-components": "static-1.565",
  "breeze-engine-core": "static-1.865",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "navigation-messaging": "static-1.8053",
  "content-media-composition-data-lib": "static-1.13134",
  "content-media-compositions": "static-2.17141",
  "idb-keyval": "static-1.48",
  "media-bridge-lib": "static-1.19346",
  "unified-auth-core-lib": "static-1.1100",
  "social-insights-client-types": "static-1.22685",
  "advanced-menus-core": "static-1.15517",
  "advanced-menus-lib": "static-1.12397",
  "ExportDialog": "static-6.10632",
  "ui-memberships-settings-lib": "static-1.34751",
  "conditional-properties-service-client": "static-1.3982",
  "crm-pipelines-api-client-types": "static-1.4316",
  "fdsr-migration-layer": "static-1.264",
  "framework-builder-read-service-client": "static-1.4188",
  "framework-data-schema-quick-fetch": "static-1.7050",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3876",
  "persist-promise": "static-1.3952",
  "foundations-components-test-utils": "static-1.5883",
  "reactive-lib": "static-1.975",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.592",
  "universal-page-editor-lib": "static-1.3261",
  "adobe-sign-auth-lib": "static-1.366",
  "ads-unified-auth-lib": "static-1.1101",
  "google-sheets-integration-lib": "static-1.943",
  "microsoft-drive-auth-lib": "static-1.35",
  "surveymonkey-integration-lib": "static-1.386",
  "slack-ui-library": "static-1.10652",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3993",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15516",
  "simple-menus-lib": "static-1.17033",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.10002",
  "react-flip-move": "static-1.75"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30720",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55233",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8280",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11737",
  "I18n": "/I18n/static-7.1664",
  "quartz": "/quartz/static-1.7384",
  "quartz-config": "/quartz-config/static-1.1162",
  "quartz-core": "/quartz-core/static-1.6603",
  "react-dlb": "/react-dlb/static-1.85",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reselect": "/reselect/static-3.9",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.873",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55220",
  "feedback-utils": "/feedback-utils/static-1.55224",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4719",
  "forms-utils-lib": "/forms-utils-lib/static-1.13029",
  "foundations-assets": "/foundations-assets/static-1.5133",
  "foundations-components": "/foundations-components/static-1.8400",
  "foundations-theming": "/foundations-theming/static-1.4717",
  "hub-http": "/hub-http/static-1.6467",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12044",
  "icons": "/icons/static-2.675",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4100",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.191",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-unify-reporter-duration-calculations.9",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5522",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.496",
  "tinymce-plugins": "/tinymce-plugins/static-1.58130",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1231",
  "UIComponents": "/UIComponents/static-3.8683",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3585",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3661",
  "quartz-webpack": "/quartz-webpack/static-1.3608",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2433",
  "property-description-translator": "/property-description-translator/static-1.4094",
  "HeadJS": "/HeadJS/static-2.790",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3391",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4571",
  "jasmine-runner": "/jasmine-runner/static-1.6702",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.20",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4830",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.568",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.395",
  "quartz-auth": "/quartz-auth/static-1.1059",
  "quartz-head": "/quartz-head/static-1.1049",
  "quartz-i18n": "/quartz-i18n/static-1.1059",
  "quartz-routing": "/quartz-routing/static-1.814",
  "quartz-test": "/quartz-test/static-1.1059",
  "quartz-tracking": "/quartz-tracking/static-1.763",
  "trellis-components": "/trellis-components/static-1.2513",
  "ui-fonts": "/ui-fonts/static-1.999",
  "usage-tracker-container": "/usage-tracker-container/static-1.7600",
  "usage-tracker-core": "/usage-tracker-core/static-1.7460",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7502",
  "reference-resolvers": "/reference-resolvers/static-1.8433",
  "sanitize-text": "/sanitize-text/static-1.8404",
  "PatternValidationJS": "/PatternValidationJS/static-1.3151",
  "ReduxMessenger": "/ReduxMessenger/static-2.10619",
  "sanitize": "/sanitize/static-1.4728",
  "outpost": "/outpost/static-1.4414",
  "rpc-client-utils": "/rpc-client-utils/static-1.4917",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4669",
  "floating-ui": "/floating-ui/static-1.62",
  "hs-story-utils": "/hs-story-utils/static-1.9680",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2494",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3200",
  "foundations-theming-base": "/foundations-theming-base/static-1.3702",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.261",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9607",
  "atom": "/atom/static-1.5340",
  "codemirror": "/codemirror/static-5.99",
  "content-assistance-lib": "/content-assistance-lib/static-1.8141",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "data-token-picker": "/data-token-picker/static-1.16822",
  "file-manager-components": "/file-manager-components/static-1.24374",
  "FileManagerCore": "/FileManagerCore/static-1.39873",
  "FileManagerLib": "/FileManagerLib/static-1.40014",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8181",
  "hub-http-contrib": "/hub-http-contrib/static-1.3292",
  "interframe": "/interframe/static-3.5008",
  "layout-dnd-components": "/layout-dnd-components/static-1.12900",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11875",
  "property-translator": "/property-translator/static-1.5650",
  "react-codemirror": "/react-codemirror/static-1.10893",
  "react-colorpicker": "/react-colorpicker/static-2.10462",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8354",
  "rich-text-lib": "/rich-text-lib/static-1.20243",
  "tinymce-data": "/tinymce-data/static-1.41101",
  "tinymce-themes": "/tinymce-themes/static-1.56986",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10138",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5468",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16243",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10538",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10536",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5296",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1219",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.327",
  "chirp-fetch": "/chirp-fetch/static-1.2146",
  "chatspot-core": "/chatspot-core/static-1.22675",
  "copilot-toolkit": "/copilot-toolkit/static-1.11758",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13283",
  "data-fetching-client": "/data-fetching-client/static-1.9910",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5009",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8956",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29227",
  "usage-tracker": "/usage-tracker/static-1.7610",
  "cms-field-types": "/cms-field-types/static-1.5069",
  "content-icons-ui": "/content-icons-ui/static-1.2318",
  "integrations-lib": "/integrations-lib/static-1.16939",
  "customer-data-objects": "/customer-data-objects/static-1.7939",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1587",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4911",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "graphql": "/graphql/static-1.86",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4405",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9329",
  "video-components-external": "/video-components-external/static-1.12075",
  "video-data-lib": "/video-data-lib/static-1.35733",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.205",
  "audio-components": "/audio-components/static-1.6280",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29743",
  "FileManagerImages": "/FileManagerImages/static-1.37525",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1425",
  "html-to-image": "/html-to-image/static-1.58",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "salesImages": "/salesImages/static-1.530",
  "ui-universal-auth": "/ui-universal-auth/static-1.9304",
  "urlinator": "/urlinator/static-1.4785",
  "video-components": "/video-components/static-1.14077",
  "video-embed": "/video-embed/static-1.36567",
  "ts-schema": "/ts-schema/static-1.4261",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10200",
  "react-dnd-compat": "/react-dnd-compat/static-1.4869",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1795",
  "external-options-client-types": "/external-options-client-types/static-1.4307",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7145",
  "hs-promise-utils": "/hs-promise-utils/static-1.5849",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4025",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9229",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3315",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11396",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5723",
  "magpie-types": "/magpie-types/static-1.5183",
  "simple-logging-lib": "/simple-logging-lib/static-1.3305",
  "avatar-components": "/avatar-components/static-1.2750",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10080",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6837",
  "flux-actions": "/flux-actions/static-1.361",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5133",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14354",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5862",
  "laboratory-lib": "/laboratory-lib/static-3.7406",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8031",
  "redux-observable": "/redux-observable/static-1.72",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10518",
  "unified-auth": "/unified-auth/static-1.818",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.565",
  "breeze-engine-core": "/breeze-engine-core/static-1.865",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "navigation-messaging": "/navigation-messaging/static-1.8053",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13134",
  "content-media-compositions": "/content-media-compositions/static-2.17141",
  "idb-keyval": "/idb-keyval/static-1.48",
  "media-bridge-lib": "/media-bridge-lib/static-1.19346",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1100",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15517",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12397",
  "ExportDialog": "/ExportDialog/static-6.10632",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34751",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3982",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4316",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.264",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4188",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7050",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3876",
  "persist-promise": "/persist-promise/static-1.3952",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5883",
  "reactive-lib": "/reactive-lib/static-1.975",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.592",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3261",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.366",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1101",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.943",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.35",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.386",
  "slack-ui-library": "/slack-ui-library/static-1.10652",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3993",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15516",
  "simple-menus-lib": "/simple-menus-lib/static-1.17033",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10002",
  "react-flip-move": "/react-flip-move/static-1.75"
}
};
